import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
  emptyData: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "calc(10px + 2vmin)",
    height: "calc(100vh - 400px)",
  },
});
